import React,{ Component } from 'react';
import { HashRouter, Route, Switch} from 'react-router-dom';
import './static/config';
import SystemLogin from "./login/login";
import Navigation from "./ContentPages/Navigation";
import register from "./login/register";
import forgetPassword from "./login/forgetPassword";
import RegisterCertificatePapers from "./ContentPages/QualificationCertificate/RegisterCertificatePapers";
import TechnicalFieldDescription from "./ContentPages/QualificationCertificate/TechnicalFieldDescription";
import IPNonReuse from "./ContentPages/IntellectualProperty/IPNonReuse";
import IPSummaryTable from "./ContentPages/IntellectualProperty/IPSummaryTable";
import IPUploadSupportPapers from "./ContentPages/IntellectualProperty/IPUploadSupportPapers";
import EnterpriseRegistration from "./ContentPages/NationalPages/EnterpriseRegistration";
import superMaster from "./ContentPages/superMaster/superMaster";
import SuperManagerList from "./ContentPages/superMaster/SuperManagerList";
import SuperUserList from "./ContentPages/superMaster/SuperUserList";
import UserList from "./ContentPages/commonMaster/UserList";
import PrivateRoute from "./PrivateRoute";
import CompanyList from "./ContentPages/Lists/CompanyListNavigation";
import CompanyListNavigation from "./ContentPages/Lists/CompanyListNavigation";
import HighTechList from "./ContentPages/Lists/HighTechList";
import ProjectList from "./ContentPages/Lists/ProjectList";
import ResearchAuditReport from "./ContentPages/AuditReport/ResearchAuditReport";
import ProductAuditReport from "./ContentPages/AuditReport/ProductAuditReport";
import FinancialAuditReport from "./ContentPages/AuditReport/FinancialAuditReport";
import TaxForm from "./ContentPages/AuditReport/TaxForm";
import IntermediaryProof from "./ContentPages/AuditReport/IntermediaryProof";
import IPFunction from "./ContentPages/IntellectualProperty/IPFunction";
import IPGeneralSituation from "./ContentPages/IntellectualProperty/IPGeneralSituation";
import IPSummaryTableQingdao from './ContentPages/IntellectualProperty/IPSummaryTableQingdao';
import PatentTransferSummaryQingdao from './ContentPages/PatentTransfer/PatentTransferSummaryQingdao';
import PatentTransferSummary from './ContentPages/PatentTransfer/PatentTransferSummary';
import OverallCondition from './ContentPages/PatentTransfer/OverallCondition';
import ItemCondition from './ContentPages/PatentTransfer/ItemCondition';
import SupportingPapers from './ContentPages/PatentTransfer/SupportingPapers';
import BuildProjectSummary from "./ContentPages/BuildProject/BuildProjectSummary";
import BuildProjectResolution from "./ContentPages/BuildProject/BuildProjectResolution";
import ProjectReport from "./ContentPages/BuildProject/ProjectReport";
import ReceivingReport from "./ContentPages/BuildProject/ReceivingReport";
import StaffSituation from "./ContentPages/Staff/StaffSituation";
import StaffRoster from "./ContentPages/Staff/StaffRoster";
import StaffStructure from "./ContentPages/Staff/StaffStructure";
import StaffSecurity from "./ContentPages/Staff/StaffSecurity";
import HighTechSpecific from "./ContentPages/HighTech/HighTechSpecific";
import HighTechUpload from "./ContentPages/HighTech/HighTechUpload";
import OrganizationOverAll from "./ContentPages/organization/OrganizationOverAll";
import OrganizationItem from "./ContentPages/organization/OrganizationItem";
import RDProjectManage from "./ContentPages/organization/RDProjectManage";
import RDCenterFound from "./ContentPages/organization/RDCenterFound";
import RDCenter from "./ContentPages/organization/RDCenter";
import RDEquipment from "./ContentPages/organization/RDEquipment";
import RDExpense from "./ContentPages/organization/RDExpense";
import SupportingPapersQingdao from "./ContentPages/PatentTransfer/SupportingPapersQingdao";
import OpenInnovation from "./ContentPages/organization/OpenInnovation";
import TechPersonTrain from "./ContentPages/organization/TechPersonTrain";
import TechPersonRefresh from "./ContentPages/organization/TechPersonRefresh";
import TalentAcquisition from "./ContentPages/organization/TalentAcquisition";
import PerformanceReview from "./ContentPages/organization/PerformanceReview";
import RDInvestManage from "./ContentPages/organization/RDInvestManage";
import RDAuxiliaryAccount from "./ContentPages/organization/RDAuxiliaryAccount";
import ReserveFund from "./ContentPages/organization/ReserveFund";
import SchoolProtocol from "./ContentPages/organization/SchoolProtocol";
import PatentTransferManage from "./ContentPages/organization/PatentTransferManage";
import RDEquipmentPhoto from "./ContentPages/organization/RDEquipmentPhoto";
import HonorQualification from "./ContentPages/HonorQualification";
import SuperSystemManage from "./ContentPages/superMaster/SuperSystemManage";
import OtherReport from "./ContentPages/AuditReport/OtherReport";
import {fetchPost} from "./static/util/fetch";
import FinallyFile from "./ContentPages/FinallyFile";
import BuildProject from "./ContentPages/BuildProject/BuildProject";
/*import loadable from "../../static/util/loadable";*/

/*const SystemLogin = loadable(() => import('./'));
const CompanyListNavigation = loadable(() => import('./companylistnavigation'));*/

class PageRouter extends Component {
    componentDidMount() {
        fetchPost(global.constants.getSysConfig,{})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            systemName:res.data.systemName,
                        }))
                        if(res.data.systemColor === 1){
                            require([`./style.css`], function(list){});
                        }
                        if(res.data.systemColor === 2){
                            require([`./styleOrange.css`], function(list){});
                        }
                        if(res.data.systemColor === 3){
                            require([`./styleGray.css`], function(list){});
                        }
                    }
                }
            )
    }
    render(){
        return(
            <div>
                <HashRouter>
                    <div>
                        <Switch>
                        <PrivateRoute  path='/superMaster' component={superMaster}/>
                        <PrivateRoute  path='/superMaster/superManagerList' component={SuperManagerList}/>
                        <PrivateRoute  path='/superMaster/superuserList' component={SuperUserList}/>
                        <PrivateRoute  path='/superMaster/superSystemManage' component={SuperSystemManage}/>
                        <PrivateRoute  path='/companylistnavigation' component={CompanyListNavigation}/>
                        <PrivateRoute  path='/companylistnavigation/userList' component={UserList}/>
                        <PrivateRoute  path='/companylistnavigation/superSystemManage' component={SuperSystemManage}/>
                        <PrivateRoute  path='/companylistnavigation/companylist' component={CompanyList}/>
                        <PrivateRoute  path='/companylistnavigation/hightechlist' component={HighTechList}/>
                        <PrivateRoute  path='/companylistnavigation/projectlist' component={ProjectList}/>
                        <PrivateRoute  path='/companylistnavigation/iplist' component={IPSummaryTable}/>
                        {/*<Route  exact path='/register' component={register}/>*/}
                        <Route  exact path='/forgetPassword' component={forgetPassword}/>
                        <PrivateRoute  path='/navigation' component={Navigation}/>
                        <PrivateRoute  path='/navigation/enterpriseregistration' component={EnterpriseRegistration}/>
                        <PrivateRoute  path='/navigation/registercertificatepapers' component={RegisterCertificatePapers}/>
                        <PrivateRoute  path="/navigation/technicalfielddescription" component={TechnicalFieldDescription}/>
                        <PrivateRoute  path='/navigation/ipnonreuse' component={IPNonReuse}/>
                        <PrivateRoute  path='/navigation/ipsummarytable' component={IPSummaryTable}/>
                        <PrivateRoute   path='/navigation/ipsummarytableqingdao' component={IPSummaryTableQingdao}/>
                        <PrivateRoute   path='/navigation/ipgeneralsituation' component={IPGeneralSituation}/>
                        <PrivateRoute   path='/navigation/IPUploadsupportpapers' component={IPUploadSupportPapers}/>
                        <PrivateRoute   path='/navigation/ipfunction' component={IPFunction}/>
                        <PrivateRoute  path='/navigation/researchauditreport' component={ResearchAuditReport}/>
                        <PrivateRoute   path='/navigation/productauditreport' component={ProductAuditReport}/>
                        <PrivateRoute  path='/navigation/financialauditreport' component={FinancialAuditReport}/>
                        <PrivateRoute   path='/navigation/taxform' component={TaxForm}/>
                        <PrivateRoute  path='/navigation/intermediaryproof' component={IntermediaryProof}/>
                        {/*<PrivateRoute  path='/navigation/otherReport' component={OtherReport}/>*/}
                        <PrivateRoute  path='/navigation/patenttransfersummaryqingdao' component={PatentTransferSummaryQingdao}/>
                        <PrivateRoute  path='/navigation/patenttransfersummary' component={PatentTransferSummary}/>
                        <PrivateRoute  path='/navigation/overallcondition' component={OverallCondition}/>
                        <PrivateRoute  path='/navigation/itemcondition' component={ItemCondition}/>
                        <PrivateRoute  path='/navigation/supportingpapers' component={SupportingPapers}/>
                        <PrivateRoute  path='/navigation/supportingpapersQingdao' component={SupportingPapersQingdao}/>
                        <PrivateRoute  path='/navigation/buildprojectsummary' component={BuildProjectSummary}/>
                        <PrivateRoute  path='/navigation/buildProject' component={BuildProject}/>
                        {/*<PrivateRoute  path='/navigation/buildprojectresolution' component={BuildProjectResolution}/>*/}
                        {/*<PrivateRoute  path='/navigation/projectreport' component={ProjectReport}/>*/}
                        {/*<PrivateRoute  path='/navigation/receivingreport' component={ReceivingReport}/>*/}
                        <PrivateRoute  path='/navigation/staffSituation' component={StaffSituation}/>
                        <PrivateRoute  path='/navigation/staffRoster' component={StaffRoster}/>
                        <PrivateRoute  path='/navigation/staffStructure' component={StaffStructure}/>
                        <PrivateRoute  path='/navigation/staffSecurity' component={StaffSecurity}/>
                        <PrivateRoute  path='/navigation/highTechSpecific' component={HighTechSpecific}/>
                        <PrivateRoute  path='/navigation/highTechUpload' component={HighTechUpload}/>
                        <PrivateRoute  path='/navigation/organizationOverAll' component={OrganizationOverAll}/>
                        <PrivateRoute  path='/navigation/organizationItem' component={OrganizationItem}/>
                        <PrivateRoute  path='/navigation/RDProjectManage' component={RDProjectManage}/>
                        <PrivateRoute  path='/navigation/RDInvestManage' component={RDInvestManage}/>
                        <PrivateRoute  path='/navigation/RDAuxiliaryAccount' component={RDAuxiliaryAccount}/>
                        <PrivateRoute  path='/navigation/ReserveFund' component={ReserveFund}/>
                        <PrivateRoute  path='/navigation/RDCenterFound' component={RDCenterFound}/>
                        <PrivateRoute  path='/navigation/RDCenter' component={RDCenter}/>
                        <PrivateRoute  path='/navigation/RDEquipment' component={RDEquipment}/>
                        <PrivateRoute  path='/navigation/SchoolProtocol' component={SchoolProtocol}/>
                        <PrivateRoute  path='/navigation/PatentTransferManage' component={PatentTransferManage}/>
                        <PrivateRoute  path='/navigation/OpenInnovation' component={OpenInnovation}/>
                        <PrivateRoute  path='/navigation/TechPersonTrain' component={TechPersonTrain}/>
                        <PrivateRoute  path='/navigation/TechPersonRefresh' component={TechPersonRefresh}/>
                        <PrivateRoute  path='/navigation/TalentAcquisition' component={TalentAcquisition}/>
                        <PrivateRoute  path='/navigation/PerformanceReview' component={PerformanceReview}/>
                        <PrivateRoute  path='/navigation/RDEquipmentPhoto' component={RDEquipmentPhoto}/>
                        <PrivateRoute  path='/navigation/RDExpense' component={RDExpense}/>
                        <PrivateRoute  path='/navigation/honorQualification' component={HonorQualification}/>
                        <PrivateRoute  path='/navigation/finallyFile' component={FinallyFile}/>
                            <Route  exact path='/' component={SystemLogin}/>
                        </Switch>
                    </div>
                </HashRouter>
            </div>
        )
    }
}
export default PageRouter;